import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IListState, PaginationType } from '@typings/requestPayloads'

export interface IMeetingCostListPayload {
    pagination?: PaginationType
}

const initialState: IListState = {
    status: STATUS.IDLE,
    data: [],
    pagination: {
        skip: 0,
        hasTotal: true,
        total: 0,
        limit: 10
    },
    errors: null
}

const meetingCostList = createSlice({
    name: 'meeting/meeting-cost-list',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IMeetingCostListPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            if (action.payload?.noSaveInStore !== true) {
                state.data = action.payload.data
                state.pagination = {
                    ...state.pagination,
                    skip: action.payload.skip,
                    total: action.payload.total
                }
            }
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const meetingCostListActions = meetingCostList.actions
export default meetingCostList.reducer
